import React from 'react';

// ─── STEP INDICATOR ───
const StepIndicator = React.memo(({ step }) => {
  // step 2=TC, 3=Plaka, 4=Ruhsat → gosterim 1,2,3
  const displayStep = step - 1;
  return (
    <div className="flex items-center justify-center gap-2 mb-5">
      {[1, 2, 3].map((s) => (
        <React.Fragment key={s}>
          <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300
            ${displayStep >= s
              ? 'bg-gradient-to-br from-[#0189ec] to-[#00c8ff] text-white shadow-md'
              : 'bg-gray-100 text-gray-400 border border-gray-200'
            }
            ${displayStep === s ? 'ring-4 ring-blue-100 scale-110' : ''}
          `}>
            {displayStep > s ? (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : s}
          </div>
          {s < 3 && (
            <div className={`w-10 sm:w-14 h-1 rounded-full transition-all duration-500 ${displayStep > s ? 'bg-gradient-to-r from-[#0189ec] to-[#00c8ff]' : 'bg-gray-200'}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
});

const OnlineTrafikSigortasi2 = ({
  step, formData, error,
  onTcChange, onPhoneChange, onBirthDateChange,
  onPlateChange, onBelgeSeriChange, onBelgeNoChange,
  onStep1Submit, onStep2Submit, onStep3Submit,
  onGoBack, formatPhone
}) => {
  return (
    <div className="max-w-md mx-auto animate-slide-up">

      <StepIndicator step={step} />

      {/* ─── STEP 2 (form step 1): TC + Dogum + Telefon ─── */}
      {step === 2 && (
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg shadow-orange-100/30 border border-white/80">
          <div className="text-center mb-5">
            <h2 className="text-lg font-bold text-gray-800">Bilgilerinizi Girin</h2>
            <p className="text-gray-500 text-sm mt-1">Sigo sizin için en uygun teklifi bulsun</p>
          </div>

          <form onSubmit={onStep1Submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">T.C No veya Vergi No</label>
              <input
                type="text" inputMode="numeric"
                value={formData.tcNo} onChange={onTcChange}
                placeholder="TC Kimlik Numaranızı veya Vergi Numaranız"
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#24b9fa] focus:ring-2 focus:ring-sky-100 outline-none text-base bg-white/80 transition-all"
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Doğum Tarihi</label>
              <input
                type="text" inputMode="numeric"
                value={formData.birthDate} onChange={onBirthDateChange}
                placeholder="GG/AA/YYYY" maxLength={10}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#24b9fa] focus:ring-2 focus:ring-sky-100 outline-none text-base bg-white/80 transition-all"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Telefon Numarası</label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium">+90</span>
                <input
                  type="tel"
                  value={formatPhone(formData.phone)} onChange={onPhoneChange}
                  placeholder="5XX XXX XXXX"
                  className="w-full pl-14 pr-4 py-3 rounded-xl border border-gray-200 focus:border-[#24b9fa] focus:ring-2 focus:ring-sky-100 outline-none text-base tracking-wide bg-white/80 transition-all"
                />
              </div>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
              </div>
            )}

            <div className="flex items-start gap-2 text-xs text-gray-500 pt-1">
              <input type="checkbox" defaultChecked className="mt-0.5 rounded" />
              <span>
                <a href="/kvkk" target="_blank" rel="noopener noreferrer" className="text-[#24b9fa] hover:underline">KVKK</a>
                {' ve '}
                <a href="/aydinlatma-metni" target="_blank" rel="noopener noreferrer" className="text-[#24b9fa] hover:underline">kullanım koşullarını</a>
                {' kabul ediyorum'}
              </span>
            </div>

            <button type="submit" className="w-full py-3.5 rounded-lg bg-[#0189ec] hover:bg-[#0070c9] text-white font-semibold text-base shadow-lg shadow-blue-200/40 hover:shadow-xl hover:scale-[1.01] transition-all active:scale-[0.98] flex items-center justify-center gap-2">
              Sigo ile Teklif Al
            </button>
          </form>
        </div>
      )}

      {/* ─── STEP 3 (form step 2): Plaka ─── */}
      {step === 3 && (
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg shadow-orange-100/30 border border-white/80">
          <div className="text-center mb-5">
            <h2 className="text-lg font-bold text-gray-800">Araç Plakanız</h2>
            <p className="text-gray-500 text-sm mt-1">Aracınızın plakasını giriniz</p>
          </div>

          <form onSubmit={onStep2Submit} className="space-y-4">
            <div>
              <div className="relative flex items-stretch border-2 border-gray-300 rounded-lg overflow-hidden bg-white focus-within:border-[#0189ec] focus-within:ring-2 focus-within:ring-blue-100 transition-all">
                {/* Sol: Türk plaka mavi şerit */}
                <div className="w-12 bg-[#003399] flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-white">TR</span>
                </div>
                {/* Sağ: Plaka input */}
                <input
                  type="text"
                  value={formData.plate} onChange={onPlateChange}
                  placeholder="34 ABC 123"
                  className="flex-1 px-4 py-4 outline-none text-2xl text-center font-bold tracking-widest uppercase bg-transparent"
                  autoFocus
                />
              </div>
              <p className="text-xs text-gray-400 mt-2 text-center">Örnek: 34ABC123, 06AB1234</p>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
              </div>
            )}

            <div className="flex gap-3">
              <button type="button" onClick={() => onGoBack(2)}
                className="px-6 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-all">
                Geri
              </button>
              <button type="submit"
                className="flex-1 py-3 rounded-lg bg-[#0189ec] hover:bg-[#0070c9] text-white font-semibold shadow-lg shadow-blue-200/40 hover:shadow-xl hover:scale-[1.01] transition-all active:scale-[0.98]">
                Devam
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ─── STEP 4 (form step 3): Ruhsat Belge ─── */}
      {step === 4 && (
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg shadow-orange-100/30 border border-white/80">
          <div className="text-center mb-5">
            <h2 className="text-lg font-bold text-gray-800">Ruhsat Bilgileri</h2>
            <p className="text-gray-500 text-sm mt-1">Araç ruhsatınızdaki belge seri ve numarasını girin</p>
          </div>

          <form onSubmit={onStep3Submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Belge Seri ve Numarası</label>
              <div className="flex gap-3">
                <div className="w-1/3">
                  <input
                    type="text"
                    value={formData.belgeSeri} onChange={onBelgeSeriChange}
                    placeholder="AA"
                    className="w-full px-3 py-3.5 rounded-xl border-2 border-gray-200 focus:border-[#24b9fa] focus:ring-2 focus:ring-sky-100 outline-none text-lg text-center font-bold uppercase tracking-widest bg-white/80"
                    autoFocus maxLength={3}
                  />
                  <p className="text-xs text-gray-400 mt-1 text-center">Seri (Harf)</p>
                </div>
                <div className="flex-1">
                  <input
                    type="text" inputMode="numeric"
                    value={formData.belgeNo} onChange={onBelgeNoChange}
                    placeholder="000000"
                    className="w-full px-3 py-3.5 rounded-xl border-2 border-gray-200 focus:border-[#24b9fa] focus:ring-2 focus:ring-sky-100 outline-none text-lg text-center font-bold tracking-widest bg-white/80"
                    maxLength={8}
                  />
                  <p className="text-xs text-gray-400 mt-1 text-center">Numara (Rakam)</p>
                </div>
              </div>
            </div>

            <div className="bg-[#24b9fa]/5 rounded-xl p-3 flex items-start gap-2">
              <svg className="w-4 h-4 text-[#24b9fa] mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <p className="text-xs text-gray-600 leading-relaxed">
                Ruhsat numarasını, ruhsatınızın sağ alt köşesinde bulabilirsiniz. Örnek: <strong>BA 123456</strong>
              </p>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600 flex items-center gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg> {error}
              </div>
            )}

            <div className="flex gap-3">
              <button type="button" onClick={() => onGoBack(3)}
                className="px-6 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-all">
                Geri
              </button>
              <button type="submit"
                className="flex-1 py-3.5 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold text-base shadow-lg shadow-green-200/50 hover:shadow-xl hover:scale-[1.01] transition-all active:scale-[0.98] flex items-center justify-center gap-2">
                Fiyat Al
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Mobil bilgi kartlari - sadece step 2'de */}
      {step === 2 && (
        <div className="lg:hidden mt-6 grid grid-cols-2 gap-3">
          {['AI Fiyat Analizi', '30 Saniyede Sonuç', 'Güvenli Ödeme', '7/24 Destek'].map((label, i) => (
            <div key={i} className="bg-white/80 backdrop-blur-sm rounded-xl p-3 border border-white/80 shadow-sm text-center">
              <p className="text-xs text-gray-600 font-medium">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OnlineTrafikSigortasi2;
